'use client';

import { useFiltersContext } from '@components/FilterPage/Context/useFiltersContext';
import { Flex, freddyTheme, Switch, Typography } from '@coolblue-development/freddy';
import { SmileHappy } from '@coolblue-development/icons';
import { useTranslation } from '@i18n/useTranslation';

export const InternalUserFacet = () => {
  const { t } = useTranslation('filterPage.filterFacets');

  const { getSelectedFilterOptions, setFilter } = useFiltersContext();

  const internalOnly = getSelectedFilterOptions('visibility').includes('internal');

  return (
    <Flex alignItems='center' gap={freddyTheme.spacing[200]}>
      <Switch
        checked={internalOnly}
        onChange={() => setFilter('visibility', internalOnly ? [] : ['internal'])}
        sx={{
          backgroundColor: internalOnly
            ? freddyTheme.color.background.interactiveActionBase
            : undefined
        }}
        aria-label='Internal vacancies switcher'
      />
      <Flex alignItems='center' gap={freddyTheme.spacing[100]}>
        <SmileHappy size='large' fill={freddyTheme.color.font.headingMain} />
        <Typography
          fontWeight={freddyTheme.typography.fontWeight.dobraSlab.medium}
          fontFamily='DobraSlabMedium'
          color={freddyTheme.color.font.headingMain}
        >
          {t('visibility.label')}
        </Typography>
      </Flex>
    </Flex>
  );
};
